import React, { useState } from "react";
import BodyHeader from "../common/BodyHeader";
import PlusIcon from "assets/icons/Plus.svg";
import SearchBar from "../common/SearchBarActivities";
import GenericTable from "../common/GenericTable";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ViewIcon from "assets/icons/View.svg";

const paymentHeaders = [
  "DATE",
  "TRANSACTION",
  "TYPE",
  "PROPERTY",
  "AMOUNT",
  "STATUS",
  "ACTIONS",
];

const paymentRows = [
  {
    date: "Jun 14, 2025",
    transaction: "Payment to James Plumbing Co. for HVAC Repair",
    type: "Vendor Payout",
    property: "Pine Avenue Duplex",
    amount: "-$250.00",
    status: "Completed",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Refund to Landlord for Cancelled Job",
    type: "Job Payment",
    property: "Downtown Loft",
    amount: "+$300.00",
    status: "Pending",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Platform Service Fee Deducted",
    type: "Refund",
    property: "Oak Street House",
    amount: "-$100.00",
    status: "Pending",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Payment to James Plumbing Co. for HVAC Repair",
    type: "Vendor Payout",
    property: "Pine Avenue Duplex",
    amount: "+$50.00",
    status: "Completed",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Refund to Landlord for Cancelled Job",
    type: "Job Payment",
    property: "Downtown Loft",
    amount: "+$300.00",
    status: "Completed",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Window Platform Service Fee Deducted",
    type: "Refund",
    property: "Downtown Loft",
    amount: "-$15.00",
    status: "Pending",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Payment to James Plumbing Co. for HVAC Repair",
    type: "Vendor Payout",
    property: "Pine Avenue Duplex",
    amount: "+$50.00",
    status: "Completed",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Platform Service Fee Deducted",
    type: "Job Payment",
    property: "Oak Street House",
    amount: "+$300.00",
    status: "Completed",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Refund to Landlord for Cancelled Job",
    type: "Refund",
    property: "Downtown Loft",
    amount: "-$15.00",
    status: "Pending",
  },
  {
    date: "Jun 14, 2025",
    transaction: "Payment to James Plumbing Co. for HVAC Repair",
    type: "Vendor Payout",
    property: "Pine Avenue Duplex",
    amount: "-$100.00",
    status: "Completed",
  },
];

const TransactionHistory = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const handleManageClick = (event, invoice) => {
    setAnchorEl(event.currentTarget);
    setSelectedInvoice(invoice);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedInvoice(null);
  };

  const handleMenuAction = (action) => {
    console.log(`Action: ${action} for invoice:`, selectedInvoice);
    // Handle different actions here
    handleMenuClose();
  };
  const renderPaymentCell = (row, header, colIdx) => {
    switch (header) {
      case "DATE":
        return row.date;
      case "TRANSACTION":
        return row.transaction;
      case "TYPE":
        return row.type;
      case "PROPERTY":
        return row.property;
      case "AMOUNT":
        return row.amount;
      case "STATUS":
        return (
          <span
            style={{
              display: "inline-block",
              padding: "2px 16px",
              borderRadius: 16,
              background:
                row.status === "Completed"
                  ? "#E9F9EE"
                  : row.status === "Pending"
                  ? "#FFF9E5"
                  : "#FDEDED",
              color:
                row.status === "Completed"
                  ? "#2ECC71"
                  : row.status === "Pending"
                  ? "#F5B800"
                  : "#F44336",
              fontWeight: 500,
              fontSize: 14,
              border:
                row.status === "Completed"
                  ? "1px solid #B6EFCB"
                  : row.status === "Pending"
                  ? "1px solid #FFE6A1"
                  : "1px solid #F8C7C7",
            }}
          >
            {row.status}
          </span>
        );
      case "ACTIONS":
        return (
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={(event) => handleManageClick(event, row)}
              style={{
                border: "1px solid #ECECEC",
                color: "#242424",
              }}
            >
              Manage
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && selectedInvoice?.id === row.id}
              onClose={handleMenuClose}
              MenuListProps={{
                "aria-labelledby": "manage-button",
              }}
              sx={{
                mt: 1,
                "& .MuiPaper-root": {
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  minWidth: "180px",
                },
              }}
            >
              <MenuItem
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontWeight: 500,
                  color: "#333333",
                }}
                onClick={() => handleMenuAction("view")}
              >
                <img src={ViewIcon}></img>
                View
              </MenuItem>
            </Menu>
          </>
        );
      default:
        return row[header.toLowerCase()];
    }
  };
  return (
    <div className=" max-w-[1440px] m-auto md:py-12 py-8 md:px-6 px-4 ">
      <div className="pt-[70px]">
        <div className=" flex flex-col md:gap-12 gap-4 ">
          <BodyHeader
            title="Transaction History"
            description="Review all financial transactions tied to your jobs, invoices, and vendor payments. Use filters to find specific charges or time periods."
          ></BodyHeader>
          <SearchBar
            label="Search payment"
            placeholder="Search by transaction id, property, vendor, job title"
            select={[
              { label: "Status", values: ["A", "B", "C"] },
              { label: "Transaction Type", values: ["A", "B", "C"] },
              { label: "Date Range", values: ["A", "B", "C"] },
            ]}
          ></SearchBar>
          <div className="mt-6">
            <GenericTable
              resultsPerPage={10}
              headers={paymentHeaders}
              rows={paymentRows}
              renderCell={renderPaymentCell}
              pagination={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
